export enum MDSMenuDropdownSlotName {
  Trigger = "trigger",
  Menu = "menu",
}
